import React from 'react';
import TextField from 'material-ui/TextField/TextField';
import { MenuItem } from 'material-ui/Menu/index';
import { translate } from 'react-i18next';
import { withStyles } from 'material-ui';
import RoomIcon from 'material-ui-icons/Hotel';
import { Typography } from 'material-ui';

let temp = Array.from(Array(10).keys());
temp.shift();
const adultValuesDef = temp;
const kidsValuesDef = Array.from(Array(5).keys());
const agesValues = Array.from(Array(19).keys());



const styles = theme => ({
    main: {
        paddingLeft: '8px'
    },
    square: {
        border: '1px solid',
    },
    textField: {
        padding: '4px'
    },
    bedIcon: {
        color: 'white',
        opacity: '0.9',
        padding: '16px 10px 16px 10px'
    }
});

let Room = (props) => {

    let { classes, t, displayIcon, displayTitle, kidsValues, adultValues, number } = props;
    kidsValues = kidsValues || kidsValuesDef;
    adultValues = adultValues || adultValuesDef;

    return (
        <div className="cmsRoom">
            <table width="100%" className="cmsTable">
                <tbody>
                    <tr>{(displayIcon || displayTitle) ?
                        <td className="cmsFirstColumn">
                            {displayIcon ? <RoomIcon className={classes.bedIcon} /> : ''}
                            {displayTitle ? <Typography className="cmsRoomName">{t('COMMON.ROOM', { pos: number + 1 })}</Typography> : ''}
                        </td> : <td></td>}
                    <td>
                        <TextField select
                            label={t('COMMON.ADULTS')}
                            name={'adults'}
                            className="cmsFormContainer"
                            fullWidth
                            value={props.adults}
                            onChange={(event) => props.handleAdultChange(props.number, event.target.value)}
                            SelectProps={{ MenuProps: { className: classes.menu } }}
                            disabled={props.loading}>
                            {
                                adultValues.map(option => (
                                    <MenuItem key={option} value={option}>
                                        {' '}
                                        {option}{' '}
                                    </MenuItem>
                                ))
                            }
                        </TextField>
                    </td>
                    <td>
                        <TextField
                            select
                            label={t('COMMON.CHILDREN') + ' **'}
                            name={'kids'} fullWidth
                            className="cmsFormContainer"
                            value={props.kids.length}
                            onChange={(event) => props.handleKidsChange(props.number, event.target.value)}
                            SelectProps={{ MenuProps: { className: classes.menu } }}
                            disabled={props.loading}>
                            {
                                kidsValues.map(option => (
                                    <MenuItem key={'ch' + option} value={option}>
                                        {' '}
                                        {option}{' '}
                                    </MenuItem>
                                ))
                            }
                        </TextField>
                    </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td colSpan="2">
                            {props.kids.map((k, index) => {
                                return <TextField
                                    key={index}
                                    select
                                    label={t('COMMON.AGES')}
                                    style={{ width: '22%', marginRight: (index === props.kids.length - 1) ? '0px' : '8px' }}
                                    name={'age'}
                                    className="cmsFormContainer"
                                    value={k.age}
                                    onChange={(event) => props.handleKidsAgeChange(props.number, index, event.target.value)}
                                    SelectProps={{ MenuProps: { className: classes.menu } }}
                                    disabled={props.loading}>
                                    {
                                        agesValues.map(option => (
                                            <MenuItem key={option} value={option}>
                                                {' '}
                                                {option}{' '}
                                            </MenuItem>
                                        ))
                                    }
                                </TextField>;
                            })
                            }
                        </td>
                    </tr>
                </tbody>
            </table>
            <hr />
        </div >
    );
};



export default translate('translations')(withStyles(styles)(Room));


// WEBPACK FOOTER //
// ./src/components/SearchContent/Room.js